import React, { Component } from "react";
import _ from "lodash";
import { confirmAlert } from 'react-confirm-alert';
import { Control, Fieldset, Form/*, Errors*/ } from "react-redux-form";
import revision from "../../reducers/revision";
import project from "../../reducers/project";

export default class UsuariosProyectos extends Component {
  render() {
    const { projects } = this.props;
    const { users } = this.props;
    const user = this.props;
    //const { revision } = this.props;
	let usersAvailable = _.map(users, (item, i) => {
		return (<option key={i} value={item.id}> {item.name} {item.last_name} </option>);
	});

    let table = _.map(projects, (item, i) => {
      return (
        <tr key={i}>
          <td>{item.project.name}</td>
          <td>{item.state.name}</td>
          <td>{item.status} </td>
          <td>
            {_.isEmpty(item.user)
              ? <Control.select model=".user" changeAction={(model, value) => this._setUser(value)}><option value="null"> Seleccione un usuario</option>{usersAvailable}</Control.select>
              : item.user.name + " " + item.user.last_name}
          </td>
          <td>
          <Control.button model="revision" className="button is-small is-primary" disabled={item.status === "Terminado"}  onClick={() => { this._assignCommission(item.project, this.user)}}>
			{ _.isEmpty(item.user)
              ? "Asignar"
              : (item.status === "Terminado") ? 
			  "--": "Revocar" 
			  }
          </Control.button>
          </td>
        </tr>
      );
    });

   

    return (
      <div>
        <table className="table is-fullwidth inm-table no-margin">
          <thead>
            <tr>
              <th>Proyecto </th>
              <th>Estado</th>
              <th>Estatus</th>
              <th>Usuarios</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>{table}</tbody>
        </table>
      </div>
    );
  }

  _assignCommission(project, user) { 
    
	confirmAlert({
		title: '¿Está seguro?',
		message: 'Una vez iniciado el cuestionario, no prodrá ser reasignado a otro usuario.',
		confirmLabel: 'Aceptar',
		cancelLabel: 'Cancelar',
		onConfirm: () => {
			this.props.assignUserCommision(project, user);
		}
	})
  }

  _setUser(value) {
    this.user = value;
  }

}



// WEBPACK FOOTER //
// ./src/elements/revision/usuariosProyectos.jsx